module.exports = __webpack_public_path__ + "static/media/email-blue.0d25f777.svg";